<div class="wrapper pt-[40px]">
  <app-submittals-tab-group />
</div>
